import React, { memo, useContext } from 'react';
import Svg from '../icons/svg';
import { Context } from '../../../context/global-data-provider';
import { rubikaProfileUrl } from '../../../func/rubika';

function BtnContactShop({ shopData, path, ...rest }) {
  const { options } = useContext(Context);
  const profileUrl = rubikaProfileUrl(options?.rubika_shop);

  if (!(options?.rubika_shop && options?.rubika_shop_text && profileUrl)) return <div {...rest} />;

  return (
    <div {...rest}>
      <a href={profileUrl} target="_blank" rel="noopener noreferrer">
        <button
          className="w-fit btn br-c-p bc-b-c d-flex align-items-center justify-content-center px-0"
          type="button"
          style={{ minHeight: 40 }}
        >
          <Svg name="rubika" width={22} height={22} label="Rubika" />
          <span className="mr-8p font-size-5 d-flex align-items-center justify-content-center">
            {options.rubika_shop_text}
          </span>
        </button>
      </a>
    </div>
  );
}

export default memo(BtnContactShop);
